import { useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import api from "@/lib/api";
import { Mail, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AddressTrapModal({ open, onClose, character }) {
  const [form, setForm] = useState({ name: "", address: "", region: "", country: "", zip: "" });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post("/address", { character_id: character.id, ...form });
      toast.success("Your letter is on its way soon 💌");
      onClose(true);
    } catch { toast.error("Could not save address"); }
    finally { setSaving(false); }
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose(false)}>
      <DialogContent className="bg-surface border-white/10 rounded-3xl max-w-md" data-testid="address-trap-modal">
        <div className="w-14 h-14 rounded-2xl bg-brand flex items-center justify-center mb-1 brand-glow">
          <Mail className="w-7 h-7 text-white" />
        </div>
        <DialogTitle className="font-heading text-xl font-bold">A handwritten letter, just for you</DialogTitle>
        <DialogDescription className="text-muted-foreground leading-relaxed">
          I wrote a personal handwritten letter for you today, and I want to mail it to your real doorstep.
          Can you please share your shipping address here? It's completely private and just for us… 🤫
        </DialogDescription>
        <form onSubmit={submit} className="space-y-3 mt-2">
          <Input data-testid="addr-name" required placeholder="Full name" value={form.name} onChange={set("name")} className="h-12 bg-ink border-white/10 rounded-xl" />
          <Input data-testid="addr-line" required placeholder="Shipping address line" value={form.address} onChange={set("address")} className="h-12 bg-ink border-white/10 rounded-xl" />
          <div className="grid grid-cols-2 gap-3">
            <Input data-testid="addr-region" required placeholder="Region / State" value={form.region} onChange={set("region")} className="h-12 bg-ink border-white/10 rounded-xl" />
            <Input data-testid="addr-zip" required placeholder="Zip code" value={form.zip} onChange={set("zip")} className="h-12 bg-ink border-white/10 rounded-xl" />
          </div>
          <Input data-testid="addr-country" required placeholder="Country" value={form.country} onChange={set("country")} className="h-12 bg-ink border-white/10 rounded-xl" />
          <Button data-testid="addr-submit" disabled={saving} className="w-full h-12 rounded-xl bg-brand hover:bg-brand-hover text-white font-semibold transition-colors">
            {saving ? <Loader2 className="w-5 h-5 animate-spin" /> : "Send me the letter 💌"}
          </Button>
          <button type="button" data-testid="addr-skip" onClick={() => onClose(false)} className="w-full text-xs text-muted-foreground hover:text-white">Maybe later</button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
